const toSafeNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const pickDefinedNumber = (...values) => {
  for (const value of values) {
    if (value === undefined || value === null || value === "") {
      continue;
    }

    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return null;
};

export const getIngredientConsumptionQuantity = (ingredient) => {
  const explicitQuantity = pickDefinedNumber(
    ingredient?.consumptionQuantity,
    ingredient?.consumption_quantity,
    ingredient?.stockQuantity,
    ingredient?.stock_quantity,
    ingredient?.stockBaseQuantity,
    ingredient?.consumptionBaseQuantity,
    ingredient?.quantity
  );

  if (explicitQuantity !== null) {
    return Math.max(0, explicitQuantity);
  }

  return Math.max(
    0,
    toSafeNumber(ingredient?.baseQuantity ?? ingredient?.cantidad, 0)
  );
};

export const getIngredientMenuBaseQuantity = (ingredient) => {
  const explicitQuantity = pickDefinedNumber(
    ingredient?.menuBaseQuantity,
    ingredient?.menu_base_quantity,
    ingredient?.menuQuantity,
    ingredient?.menu_quantity,
    ingredient?.visibleQuantity,
    ingredient?.visible_quantity,
    ingredient?.displayQuantity,
    ingredient?.display_quantity
  );

  if (explicitQuantity !== null) {
    return Math.max(0, explicitQuantity);
  }

  return getIngredientConsumptionQuantity(ingredient) > 0 ? 1 : 0;
};

export const normalizeIngredientPortions = (ingredient = {}) => {
  const menuBaseQuantity = getIngredientMenuBaseQuantity(ingredient);
  const consumptionQuantity = getIngredientConsumptionQuantity(ingredient);

  return {
    ...ingredient,
    menuBaseQuantity,
    menuQuantity: menuBaseQuantity,
    baseQuantity: menuBaseQuantity,
    cantidad: menuBaseQuantity,
    quantity: menuBaseQuantity,
    consumptionQuantity,
    stockQuantity: consumptionQuantity,
    stockBaseQuantity: consumptionQuantity,
    consumptionBaseQuantity: consumptionQuantity,
  };
};
